import style from './../../adminSect.module.scss';

const NoPhUserDataFields = (userData) => {
  const { defaultCursor } = style;

  const roleTranslate = {
    supplier: 'proveedor',
    admin: 'admin'
  };

  const fields = [
    {
      item: {
        label: 'Número de cuenta',
        name: 'accountNumber',
      },
      input: {
        placeholder: userData.accountNumber || '',
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre completo',
        name: 'fullName',
      },
      input: {
        placeholder: userData.fullName || '',
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Número de teléfono',
        name: 'phoneNumber',
      },
      input: {
        placeholder: userData.phoneNumber || '',
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Email',
        name: 'email',
      },
      input: {
        placeholder: userData.email || '',
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Rol',
        name: 'role',
      },
      input: {
        placeholder: roleTranslate[userData.role] || '',
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
  ];
  return fields;
};

export default NoPhUserDataFields;
